<ng-container *ngIf="(inputConfig$ | async) as inputConfig">
    <div>
      <p-fileUpload
        #fileUpload
        mode="basic"
        [accept]="fileExtensions"
        chooseLabel="Odaberite"
        cancelLabel="Poništi odabir"
        (onSelect)="selectFile($event)"
        [name]="inputConfig.formControlName"
        customUpload="true"
        [disabled]="inputConfig.disabled || inputConfig.readOnly"
        (uploadHandler)="customUploader($event)"
        [maxFileSize]="primeInputConfig.maxFileSize"
        [invalidFileSizeMessageSummary]="primeInputConfig.invalidFileSizeMessageSummary"
        [invalidFileSizeMessageDetail]="primeInputConfig.invalidFileSizeMessageDetail"
        [invalidFileTypeMessageSummary]="primeInputConfig.invalidFileTypeMessageSummary"
        [invalidFileLimitMessageDetail]="primeInputConfig.invalidFileLimitMessageDetail"
        [invalidFileLimitMessageSummary]="primeInputConfig.invalidFileLimitMessageSummary">
      </p-fileUpload>
    </div>
</ng-container>